import { h, Component } from 'preact';
import { accessNested, joinClasses } from 'utils/utils';
import { convertTimeTo12Hr } from 'utils/bolt/showtimes';
import Store from 'store/store';
import Button from 'components/bolt/button/button';
import Link from 'components/bolt/link/link';
import { getProviderValues } from 'utils/bolt/showtimes';

import s from 'components/bolt/showtimes/screening.sss';

export default class Screening extends Component {
	constructor(props) {
		super(props);
		this.openInterstitial = this.openInterstitial.bind(this);
		this.linkClick = this.linkClick.bind(this);
	}

	getLinks() {
		let props = this.props;

		let comingSoonShowDeeplink = accessNested(props, 'showtimesAppData.cta.comingSoonShowDeeplink', false);

		let screening = props.screening;
		let country = (props.theater.country || '').toLowerCase();
		let providersData = accessNested(props, 'showtimesAppData.providers', {});

		if (providersData.disableLinksForCtas) {
			let providersValues = getProviderValues(providersData, 'disableLinksForCtas');
			let disableLinksForCtasCountry = providersValues[country] || providersValues.base || null;

			if (disableLinksForCtasCountry !== null) {
				if (typeof disableLinksForCtasCountry === 'string') {
					disableLinksForCtasCountry = disableLinksForCtasCountry.split(',');
				}

				disableLinksForCtasCountry = disableLinksForCtasCountry
					.map(x => +(x.trim()))
					.filter(x => x !== 0);

				if (disableLinksForCtasCountry.indexOf(screening.cta) !== -1) {
					return [];
				}
			}
		}

		if (screening.cta === 2 && !comingSoonShowDeeplink) {
			let links = [];
			if (props.theater.url) {
				links.push({ provider: 'direct', link: props.theater.url });
			}
			return links;
		}
		let links = screening && screening.link;
		return Object.keys(links).map(key => ({ provider: key, link: links[key] })).filter(e => e.link);
	}

	openInterstitial() {
		const { screening, theater, mode, isPreviewPanelScreening } = this.props;

		if (isPreviewPanelScreening) {
			this.trackTimeSelection();
			return Store.emit('OPEN_PREVIEW_PANEL_PROVIDER_INTERSTITIAL', {
				screening,
				theater
			});
		}

		this.trackTimeSelection();
		Store.emit('OPEN_PROVIDER_INTERSTITIAL', {
			screening,
			theater,
			mode
		});
	}

	linkClick(e) {
		this.trackTimeSelection();

		let props = this.props;
		if (props.trackConversion) {
			props.trackConversion(props.theater, props.screening, e.currentTarget.getAttribute('data-provider'), props.mode, e.currentTarget.href);
		}
	}

	trackTimeSelection() {
		Store.emit('SELECT_TIME', {
			screening: this.props.screening,
			theater: this.props.theater,
			mode: this.props.mode,
		}, this.props.isPreviewPanelScreening ? 'previewpanel' : 'showtimes');
	}

	getScreeningCta() {
		return this.props.screening.cta;
	}

	render(props) {
		let screening = props.screening;
		let screeningTime = screening.time;
		const { isPreviewPanelScreening } = props;
		const screeningCta = this.getScreeningCta();
		const store = Store.get();
		const fontStyles = accessNested(store, 'appData.styling.fontVariables');
		const copy = accessNested(store, 'appData.copy.baseCopy');
		const accessibilityCopy = accessNested(store, 'appData.copy.accessibilityCopy', {});
		const cta = accessNested(props, 'showtimesAppData.cta');
		let ariaLabel;

		if (props.showtimesAppData.clockFormat === '12') {
			screeningTime = convertTimeTo12Hr(screeningTime);
		}

		ariaLabel = accessibilityCopy.$SCREENING_BTN_ARIA.replace('<time>', screeningTime);

		if (screeningCta !== 1 && cta && cta[screeningCta]) {
			screeningTime = copy[cta[screeningCta]] || cta[screeningCta];
			ariaLabel = screeningTime;
		}

		let links = this.getLinks();
		let priorityProvider = accessNested(props, 'showtimesAppData.providers.priorityProvider', '');
		// TODO: add this to thundr data when bolt data inheritence is set up
		if (accessNested(store, 'appData.meta.studio.slug', '') === 'focusfeatures') {
			priorityProvider = 'fandango';
		}
		let priorityProviderLink = links.find(e => e.provider === priorityProvider);

		if (links.length === 1) {
			return (
				<Link
					class={joinClasses(s.container, s.link, fontStyles.showtimesTheaterShowtimes, isPreviewPanelScreening && s.previewPanel)}
					href={links[0].link}
					target="_blank"
					rel="noopener noreferrer"
					ariaLabel={ariaLabel}
					data-provider={links[0].provider}
					onClick={this.linkClick}
				>
					{screeningTime}
				</Link>
			);
		} else if (!!links.length && priorityProvider && priorityProviderLink) {
			return (
				<Link
					class={joinClasses(s.container, s.link, fontStyles.showtimesTheaterShowtimes)}
					href={priorityProviderLink.link}
					target="_blank"
					rel="noopener noreferrer"
					ariaLabel={ariaLabel}
					data-provider={priorityProviderLink.provider}
					onClick={this.linkClick}
				>
					{screeningTime}
				</Link>
			);
		}

		return (
			<Button
				type="time"
				class={joinClasses(s.container, fontStyles.showtimesTheaterShowtimes, !links.length && s.noLink)}
				trigger={!!links.length && this.openInterstitial}
				disabled={!links.length}
				ariaLabel={ariaLabel}
			>
				{screeningTime}
			</Button>
		);
	}
}
